function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_open-pencil",
  "data-name": "Icon open-pencil",
  d: "M12.264,0,10.22,1.939l4.088,3.878,2.044-1.939ZM8.176,3.878,0,11.634v3.878H4.088l8.176-7.756Z",
  transform: "translate(0.33)",
  fill: "#f68906"
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  id: "Line_467",
  "data-name": "Line 467",
  x2: 13.568,
  transform: "translate(0.5 17.669)",
  fill: "none",
  stroke: "#f68906",
  strokeLinecap: "round",
  strokeWidth: 1
});

var SvgPencilOrange = function SvgPencilOrange(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.682,
    height: 18.169,
    viewBox: "0 0 16.682 18.169",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPencilOrange, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pencil-orange.abd29bdb.svg";
export { ForwardRef as ReactComponent };